<template>
	<div class="guanyubody">
		<div class="w guanyuPage">
			<aboutLeft></aboutLeft>
			<div class="gy-right">
				<div class="r-title">关于我们</div>
				<div class="r-content">
					<p>逛球街（gqj.tv）是一家专业提供足球，篮球赛事视频直播的的体育直播平台。</p>
					<p>逛球街致力不断提升用户体验，努力打造成为国内顶尖的足球、篮球数据平台，为振兴国内足球、篮球事业贡献一份力量。</p>
					<span>逛球街为您提供</span>
					<span class="text-indent-40">稳定，领先的即时比分服务；</span>
					<span class="text-indent-40">全面，高清的热门赛事视频直播；</span>
					<span class="text-indent-40">专业，客观的赛事预测推荐；</span>
					<span class="text-indent-40">详细，完整的数据服务；</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import aboutLeft from '../components/AboutLeft'
	export default {
		components: {
			aboutLeft
		},
		data() {
			return {
				headCon: headCon()
			}
		},
		beforeMount() {
			var wx_login_t = this.$route.query.wx_login_t;
			if(wx_login_t){
				var href = location.href;
				if(location.href.indexOf("&") == -1){
					href = href.replace("?wx_login_t="+wx_login_t,"");
				}else{
					href = href.replace("&wx_login_t="+wx_login_t,"");
					href = href.replace("wx_login_t="+wx_login_t+"&","");
				}
				history.pushState("", "", href);
			}
		},
		mounted() {
			$("footer").show();
		},
		metaInfo() {
			return {
				title: this.headCon["guanyu"]["title"],
				meta: [{
						hid: "description",
						name: "description",
						content: this.headCon["guanyu"]["description"]
					},
					{
						hid: "keywords",
						name: 'keywords',
						content: this.headCon["guanyu"]["keywords"]
					}
				]
			};
		},
	}
</script>

<style scoped>
	@import "../../assets/css/guanyu.css";
</style>